export default __webpack_public_path__ + "static/media/card4.5704db6b.jpg";